import gql from 'graphql-tag';

export const RegionFragments = {
  id: gql`
    fragment RegionId on Region {
      id: regionCode
    }
  `,
};
